import { memo, useCallback } from 'react';
import { Button, Tooltip } from '@aimsos/ui';

/**
 * One option of the collapsed rail: just the icon, named and explained by
 * "Label · N records" (tooltip for the eye, aria-label for the screen reader).
 */
const RecordTypeRailIconItem = memo(function RecordTypeRailIconItem({
  id,
  name,
  icon,
  selected,
  onSelect,
}) {
  const handleClick = useCallback(() => onSelect(id), [onSelect, id]);

  return (
    <Tooltip content={name} size="compact" position="bottom">
      <Button
        role="option"
        aria-selected={selected}
        aria-label={name}
        variant={selected ? 'secondary' : 'ghost'}
        size="md"
        leftIcon={icon}
        onClick={handleClick}
      />
    </Tooltip>
  );
});

export default RecordTypeRailIconItem;
